import React, { useState } from 'react';
import { Button, Card, Grid } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';

import PanelImgOne from '../../../images/Panel1.svg';
import PanelImgTwo from '../../../images/Panel2.svg';
import PanelImgThree from '../../../images/Panel3.svg';
import PageWrapper from '../../PageWrapper/PageWrapper';
import { panelOneContent, panelThreeContent, panelTwoContent } from '../../../utils/Content';


const useStyles = makeStyles((theme) => ({
    pageContainer: {
        backgroundColor: '#F4F5F6'
    },
    bodyHeader: {
        fontSize: '32px',
        lineHeight: '44px',
        color: '#3B4B59',
        paddingBottom: '12px',
        fontFamily: 'Nimbus Sans Light',
    },
    bolded: {
        fontFamily: 'Nimbus Sans Bold'
    },
    bodyDetails: {
        fontSize: '20px',
        color: '#3B4B59',
        lineHeight: '32px',
        fontFamily: 'Nimbus Sans Light',
        [theme.breakpoints.down('md')]: {
            paddingBottom: '32px'
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            lineHeight: '24px'
        }
    },
    compWrapper: {
        paddingTop: '8px',
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto'
    },
    contentContainer: {
        padding: '32px',
        [theme.breakpoints.up('lg')]: {
            minHeight: '1134px'
        },
        [theme.breakpoints.down('sm')]: {
            padding: '32px 16px',
        }
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    sectionContainer: {
        paddingBottom: '16px',
        [theme.breakpoints.down('sm')]: {
            padding: '24px 0px'
        }
    },
    panelContainer: {
        [theme.breakpoints.down('md')]: {
            paddingBottom: '32px'
        }
    },
    panelImg: {
        width: '100%'
    },
    panelHeader: {
        fontFamily: 'Nimbus Sans Light',
        color: '#3B4B59',
        fontSize: '28px',
        lineHeight: '40px',
        paddingBottom: '16px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
            lineHeight: '32px'
        }
    },
    contentSecHeader: {
        paddingTop: '24px',
        fontFamily: 'Nimbus Sans Bold',
        color: '#3B4B59',
        fontSize: '20px',
        lineHeight: '32px',
        paddingBottom: '4px'
    },
    smallHeader: {
        fontFamily: 'Nimbus Sans Bold',
        color: '#3B4B59',
        fontSize: '16px',
        lineHeight: '32px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            lineHeight: '24px'
        }
    },
    mobileSmallHeader: {
        fontFamily: 'Nimbus Sans Bold',
        color: '#3B4B59',
        fontSize: '16px',
        lineHeight: '32px'
    },
    content: {
        fontSize: '16px',
        fontFamily: 'Nimbus Sans Light',
        color: '#3B4B59',
        lineHeight: '24px'
    },
    subContent: {
        fontSize: '14px',
        fontFamily: 'Nimbus Sans Light',
        color: '#3B4B59',
        lineHeight: '20px'
    }

}));

const DialogTitle = ((props) => {
    const { classes, onClose, src } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.panelImage} style={{ backgroundColor: '#1E2D39' }}>
            <div style={{ justifySelf: 'center', padding: '24px 16px', backgroundColor: '#1E2D39' }}>
                <img className={classes.panelImg} src={src} alt='chart-bubble' id='chat-bubble' />
            </div>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon style={{ color: 'white' }} />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const ImplMethod = () => {
    const classes = useStyles();
    const { invPropReview, shortTermDisc } = panelOneContent;
    const { accOpen, accFund } = panelTwoContent;
    const initialState = {
        panel1: {
            isOpen: false
        },
        panel2: {
            isOpen: false
        },
        panel3: {
            isOpen: false
        }
    }
    const { discMngmt, advRelationship } = panelThreeContent;
    const [showContent, setShow] = useState(initialState);

    return (
        <div className={classes.pageContainer} id='impl-method-container'>
            <PageWrapper bgColor='#F4F5F6'>
                <div className={classes.bodyHeader} style={{ paddingTop: '32px' }} id='impl-title'>Our Implementation Methodology</div>
                <div className={classes.bodyDetails} id='impl-copy'>
                    We consider both your current investment positions as well as your financial goals, then apply our methods
                    to implement your recommended portfolio across your household’s Retirement Advisory Service accounts.
                </div>
            </PageWrapper>
            <div className={classes.compWrapper}>
                <Grid container spacing={2} style={{ paddingBottom: '64px' }}>
                    <Grid item xs={12}>
                        <Grid container justify="center" alignItems="center" spacing={4} style={{ alignItems: 'start' }}>
                            <Grid item xs={12} md={4} className={classes.panelContainer}>
                                <Card style={{ backgroundColor: 'white' }} id='panel-1-card'>
                                    <div style={{ justifySelf: 'center', padding: '24px 16px', backgroundColor: '#1E2D39' }} id='panel-1-img-container'>
                                        <img
                                            className={classes.panelImg}
                                            src={PanelImgOne}
                                            alt='investment-proposal-img'
                                            id='investment-proposal-img'
                                        />
                                    </div>
                                    <Box display={{ xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' }}>
                                        <div className={classes.contentContainer} id='panel-1-content-container'>
                                            <div
                                                className={classes.panelHeader}
                                                style={{ borderBottom: '1px solid #05C3DE' }}
                                                id='panel-1-header'
                                            >
                                                1. Investment Proposal
                                            </div>
                                            <div className={classes.sectionContainer} style={{ paddingTop: 0 }} id='ip-review-section'>
                                                <div className={classes.contentSecHeader} id='ip-review-header'>Investment Proposal Review</div>
                                                <div className={classes.content} id='ip-review-content'>{invPropReview.content}</div>
                                                <div
                                                    className={classes.content}
                                                    style={{ padding: '32px 0px', borderBottom: '1px solid #05C3DE' }}
                                                    id='ip-review-sub-content'
                                                >
                                                    {invPropReview.subContent}
                                                </div>
                                            </div>
                                            <div className={classes.sectionContainer} style={{ paddingTop: 0 }} id='needs-disc-section'>
                                                <div
                                                    className={classes.contentSecHeader}
                                                    style={{ paddingTop: '8px' }}
                                                    id='needs-disc-header'
                                                >
                                                    Short-Term Needs Discussion
                                                </div>
                                                <div className={classes.content} id='needs-disc-content'>
                                                    {shortTermDisc.content}
                                                    <p style={{ paddingTop: '32px' }} id='needs-disc-sub-content'>{shortTermDisc.subContent}</p>
                                                </div>
                                            </div>
                                            <div className={classes.sectionContainer} id='ret-section'>
                                                <div className={classes.subContent} id='ret-section-content-container'>
                                                    <p style={{ paddingTop: '16px' }} id='pre-ret-copy'>
                                                        <span className={classes.bolded}>Pre-retirement:</span> {shortTermDisc.preRet}
                                                    </p>
                                                    <p style={{ paddingTop: '32px', marginTop: 0 }} id='in-ret-copy'>
                                                        <span className={classes.bolded}>In retirement:</span> {shortTermDisc.inRet}
                                                    </p>
                                                    <p style={{ paddingTop: '32px', marginTop: 0 }} id='disclosure-copy'>{shortTermDisc.disclosure}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Box>
                                    <Box display={{ xs: 'block', sm: 'block', md: 'none', lg: 'none', xl: 'none' }}>
                                        <div className={classes.contentContainer} id='panel-1-mobile-container'>
                                            <div
                                                className={classes.panelHeader}
                                                style={{ borderBottom: '1px solid #05C3DE' }}
                                                id='panel-1-header-mobile'
                                            >
                                                1. Investment Proposal
                                            </div>
                                            <div className={classes.sectionContainer} style={{ borderBottom: '1px solid #05C3DE' }} id='ip-review-section-mobile'>
                                                <div className={classes.smallHeader} id='ip-review-header-mobile'>Investment Proposal Review</div>
                                            </div>
                                            <div className={classes.sectionContainer} id='needs-disc-section-mobile'>
                                                <div className={classes.smallHeader} id='needs-disc-header-mobile'>Short-Term Needs Discussion</div>
                                            </div>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                style={{ width: '100%', padding: '20px 0px' }}
                                                onClick={() => setShow({ ...showContent, panel1: { isOpen: true } })}
                                                id='panel-1-details-btn'
                                            >
                                                View Details
                                                </Button>
                                        </div>
                                        <Dialog fullScreen open={showContent.panel1.isOpen} id='panel-1-PU' data-metrics-location="PU">
                                            <DialogTitle
                                                classes={classes}
                                                onClose={() => setShow({ ...showContent, panel1: { isOpen: false } })}
                                                src={PanelImgOne}
                                                id='panel-1-pu-img-container'
                                            />
                                            <div className={classes.contentContainer} id='panel-1-PU-content-container'>
                                                <div
                                                    className={classes.panelHeader}
                                                    style={{ borderBottom: '1px solid #05C3DE' }}
                                                    id='ip-PU-header'>1. Investment Proposal</div>
                                                <div className={classes.sectionContainer} id='ip-PU-section'>
                                                    <div className={classes.smallHeader} id='ip-review-PU-title'>Investment Proposal Review</div>
                                                    <div className={classes.content} id='ip-review-PU-content'>{invPropReview.content}</div>
                                                    <div
                                                        className={classes.content}
                                                        style={{ padding: '16px 0px 32px', borderBottom: '1px solid #05C3DE' }}
                                                        id='ip-review-PU-sub-content'>
                                                        {invPropReview.subContent}
                                                    </div>
                                                </div>
                                                <div className={classes.sectionContainer} style={{ padding: 0 }} id='needs-disc-PU-section'>
                                                    <div className={classes.smallHeader} id='needs-disc-PU-title'>Short-Term Needs Discussion</div>
                                                    <div className={classes.content} id='needs-disc-PU-content'>
                                                        {shortTermDisc.content}
                                                    </div>
                                                </div>
                                                <div className={classes.sectionContainer} id='ret-PU-section'>
                                                    <div className={classes.subContent} id='ret-PU-content-container'>
                                                        <div id='pre-ret-PU-content'>
                                                            <div className={classes.mobileSmallHeader} id='pre-ret-PU-title'>Pre-retirement:</div>
                                                            {shortTermDisc.preRet}
                                                        </div>
                                                        <div style={{ paddingTop: '32px', marginTop: 0 }} id='in-ret-PU-content'>
                                                            <div className={classes.mobileSmallHeader} id='in-ret-PU-title'>In retirement:</div>
                                                            {shortTermDisc.inRet}
                                                        </div>
                                                        <p style={{ padding: '16px 0 32px', marginTop: 0 }} id='needs-disc-disclosure'>{shortTermDisc.disclosure}</p>
                                                    </div>
                                                </div>
                                                <div>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        style={{ width: '100%', padding: '20px 0px' }}
                                                        onClick={() => setShow({ ...showContent, panel1: { isOpen: false }, panel2: { isOpen: true } })}
                                                        id='view-acct-set-PU-btn'
                                                    >
                                                        View Account Setup<span style={{ paddingLeft: '14px' }}>{'>'}</span>
                                                    </Button>
                                                </div>
                                            </div>
                                        </Dialog>
                                    </Box>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Card style={{ backgroundColor: 'white' }} id='panel-2-card'>
                                    <div style={{ justifySelf: 'center', padding: '24px 16px', backgroundColor: '#1E2D39' }} id='panel-2-img-container'>
                                        <img
                                            className={classes.panelImg}
                                            src={PanelImgTwo}
                                            alt='acct-set-img'
                                            id='acct-set-img'
                                        />
                                    </div>
                                    <Box display={{ xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' }}>
                                        <div className={classes.contentContainer} id='panel-2-content-container'>
                                            <div
                                                className={classes.panelHeader}
                                                style={{ borderBottom: '1px solid #8B57D9' }}
                                                id='panel-2-header'
                                            >
                                                2. Account Setup
                                            </div>
                                            <div className={classes.sectionContainer} style={{ borderBottom: '1px solid #8B57D9' }} id='acct-open-section'>
                                                <div className={classes.contentSecHeader} id='acct-open-title'>Account Opening</div>
                                                <div className={classes.content} id='acct-open-content'>
                                                    {accOpen.content}
                                                </div>
                                            </div>
                                            <div className={classes.sectionContainer} style={{ paddingTop: '4px' }} id='acct-fund-section'>
                                                <div className={classes.contentSecHeader} id='acct-fund-title'>Account Conversion and Funding</div>
                                                <div className={classes.content}id='acct-fund-content'>
                                                    {accFund.content}
                                                </div>
                                            </div>
                                            <div className={classes.sectionContainer} id='ast-strat-section'>
                                                <div className={classes.smallHeader} id='ast-strat-title'>Asset Location Strategy</div>
                                                <div className={classes.subContent} id='ast-strat-content-container'>
                                                    <p id='ast-strat-content'>{accFund.locStratOne}</p>
                                                    <p id='ast-strat-sub-content'>{accFund.locStratTwo}</p>
                                                </div>
                                            </div>
                                            <div className={classes.sectionContainer} id='cap-strat-section'>
                                                <div className={classes.smallHeader} id='cap-strat-title'>Capital Gain Minimization Strategy</div>
                                                <div className={classes.subContent} id='cap-strat-content'>
                                                    {accFund.capStrat}
                                                    <p style={{ paddingTop: '16px' }} id='ext-post-content'>
                                                        <span className={classes.bolded}>Existing Positions:</span> {accFund.extPos}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </Box>
                                    <Box display={{ xs: 'block', sm: 'block', md: 'none', lg: 'none', xl: 'none' }}>
                                        <div className={classes.contentContainer} id='panel-2-mobile-container'>
                                            <div
                                                className={classes.panelHeader}
                                                style={{ borderBottom: '1px solid #8B57D9' }}
                                                id='panel-2-mobile-header'
                                            >
                                                    2. Account Setup
                                            </div>
                                            <div className={classes.sectionContainer} style={{ borderBottom: '1px solid #8B57D9' }} id='acct-open-section-mobile'>
                                                <div className={classes.smallHeader} id='acct-open-title'>Account Opening</div>
                                            </div>
                                            <div className={classes.sectionContainer} id='acct-fund-section-mobile'>
                                                <div className={classes.smallHeader}id='acct-fund-title-mobile'>Account Conversion and Funding</div>
                                            </div>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                style={{ width: '100%', padding: '20px 0px' }}
                                                onClick={() => setShow({ ...showContent, panel2: { isOpen: true } })}
                                                id='panel-2-details-btn'
                                            >
                                                View Details
                                            </Button>
                                        </div>
                                        <Dialog fullScreen open={showContent.panel2.isOpen} id='panel-2-PU' data-metrics-location="PU">
                                            <DialogTitle
                                                classes={classes}
                                                onClose={() => setShow({ ...showContent, panel2: { isOpen: false } })}
                                                src={PanelImgTwo}
                                                id='panel-2-pu-img-container'
                                            />
                                            <div className={classes.contentContainer} id='panel-2-PU-content-container'>
                                                <div
                                                    className={classes.panelHeader}
                                                    style={{ borderBottom: '1px solid #8B57D9' }}
                                                    id='panel-2-pu-header'
                                                >
                                                    2. Account Setup
                                                </div>
                                                <div className={classes.sectionContainer} style={{ borderBottom: '1px solid #8B57D9' }} id='acct-open-section-pu'>
                                                    <div className={classes.smallHeader} style={{ padding: 0 }} id='acct-open-title-pu'>Account Opening</div>
                                                    <div className={classes.content} id='acct-open-content-pu'>
                                                        {accOpen.content}
                                                    </div>
                                                </div>
                                                <div className={classes.sectionContainer} id='acct-fund-content-container-PU'>
                                                    <div className={classes.smallHeader} style={{ padding: 0 }} id='acct-fund-title-PU'>Account Conversion and Funding</div>
                                                    <div className={classes.content} id='acct-fund-content-PU'>
                                                        {accFund.content}
                                                    </div>
                                                </div>
                                                <div className={classes.sectionContainer} id='ast-strat-section-PU' style={{ padding: 0 }}>
                                                    <div className={classes.mobileSmallHeader} id='ast-strat-title-PU'>Asset Location Strategy</div>
                                                    <div className={classes.subContent} id='ast-strat-content-container-PU'>
                                                        <p id='ast-strat-content-PU'>{accFund.locStratOne}</p>
                                                        <p id='ast-strat-sub-content-PU'>{accFund.locStratTwo}</p>
                                                    </div>
                                                </div>
                                                <div className={classes.sectionContainer} id='cap-strat-section-PU'>
                                                    <div className={classes.mobileSmallHeader} id='cap-strat-title-PU'>Capital Gain Minimization Strategy</div>
                                                    <div className={classes.subContent} id='cap-strat-content-PU'>
                                                        {accFund.capStratMobile}
                                                        <p id='ext-post-content-PU'>
                                                            <span className={classes.bolded}>Existing Positions:</span> {accFund.extPos}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div style={{ paddingBottom: '32px'}} id='panel-2-PU-btn-container'>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        style={{ width: '100%', padding: '20px 0px' }}
                                                        onClick={() => setShow({ ...showContent, panel2: { isOpen: false }, panel3: { isOpen: true } })}
                                                        id='view-ong-sup-PU-btn'
                                                    >
                                                        View Ongoing Support<span style={{ paddingLeft: '14px' }}>{'>'}</span>
                                                    </Button>
                                                </div>
                                                <div>
                                                    <Button
                                                        variant="text"
                                                        color="primary"
                                                        style={{ width: '100%', padding: '20px 0px', color: "#086EA1" }}
                                                        onClick={() => setShow({ ...showContent, panel2: { isOpen: false }, panel1: { isOpen: true } })}
                                                        id='view-inv-prop-PU-btn'
                                                    >
                                                        <span style={{ paddingRight: '14px' }}>{'<'}</span>View Investment Proposal Support
                                                </Button>
                                                </div>
                                            </div>
                                        </Dialog>
                                    </Box>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Card style={{ backgroundColor: 'white' }} id='panel-3-card'>
                                    <div style={{ justifySelf: 'center', padding: '24px 16px', backgroundColor: '#1E2D39' }} id='panel-3-img-container'>
                                        <img className={classes.panelImg} src={PanelImgThree} alt='ong-ret-img' id='ong-ret-img' />
                                    </div>
                                    <Box display={{ xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' }}>
                                        <div className={classes.contentContainer} id='panel-3-content-container'>
                                            <div
                                                className={classes.panelHeader}
                                                style={{ borderBottom: '1px solid #8EBF4C' }}
                                                id='panel-3-header'
                                            >
                                                3. Ongoing Relationship
                                            </div>
                                            <div className={classes.sectionContainer} style={{ borderBottom: '1px solid #8EBF4C' }} id='disc-man-section'>
                                                <div className={classes.contentSecHeader} id='disc-man-title'>Discretionary Management</div>
                                                <div className={classes.content} id='disc-man-content'>
                                                    {discMngmt.content}
                                                    <p style={{ paddingTop: '32px' }} id='disc-man-sub-content'>{discMngmt.subContent}</p>
                                                </div>
                                            </div>
                                            <div className={classes.sectionContainer} style={{ paddingTop: '4px' }} id='adv-rel-section'>
                                                <div className={classes.contentSecHeader} id='adv-rel-title'>Advisor Relationship</div>
                                                <div className={classes.content} id='adv-rel-content'>
                                                    {advRelationship.content}
                                                    <p style={{ paddingTop: '32px' }} id='adv-rel-sub-content'>{advRelationship.subContent}</p>
                                                </div>
                                            </div>
                                            <div className={classes.sectionContainer} id='ann-check-section'>
                                                <div className={classes.smallHeader} id='ann-check-title'>Annual Check-In</div>
                                                <div className={classes.subContent} id='ann-check-content'>{advRelationship.annCheck}</div>
                                            </div>
                                            <div className={classes.sectionContainer} id='sem-ann-check-section'>
                                                <div className={classes.smallHeader} id='sem-ann-check-title'>Semi-Annual Check-In</div>
                                                <div className={classes.subContent} id='sem-ann-check-content'>{advRelationship.semAnnCheck}</div>
                                            </div>
                                        </div>
                                    </Box>
                                    <Box display={{ xs: 'block', sm: 'block', md: 'none', lg: 'none', xl: 'none' }}>
                                        <div className={classes.contentContainer} id='panel-3-mobile-container'>
                                            <div
                                                className={classes.panelHeader}
                                                style={{ borderBottom: '1px solid #8EBF4C' }}
                                                id='panel-3-mobile-header'
                                            >
                                                3. Ongoing Relationship
                                            </div>
                                            <div className={classes.sectionContainer} style={{ borderBottom: '1px solid #8EBF4C' }} id='disc-man-section-mobile'>
                                                <div className={classes.smallHeader} id='disc-man-title-mobile'>Discretionary Management</div>
                                            </div>
                                            <div className={classes.sectionContainer} id='adv-rel-section-mobile'>
                                                <div className={classes.smallHeader} id='adv-rel-title-mobile'>Advisor Relationship</div>
                                            </div>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                style={{ width: '100%', padding: '20px 0px' }}
                                                onClick={() => setShow({ ...showContent, panel3: { isOpen: true } })}
                                                id='panel-3-details-btn'
                                            >
                                                View Details
                                            </Button>
                                        </div>
                                        <Dialog fullScreen open={showContent.panel3.isOpen} id='panel-3-PU' data-metrics-location="PU">
                                            <DialogTitle
                                                classes={classes}
                                                onClose={() => setShow({ ...showContent, panel3: { isOpen: false } })}
                                                src={PanelImgThree}
                                                id='panel-3-pu-img-container'
                                            />
                                            <div className={classes.contentContainer} id='panel-3-PU-content-container'>
                                                <div
                                                    className={classes.panelHeader}
                                                    style={{ borderBottom: '1px solid #8EBF4C' }}
                                                    id='panel-3-header'
                                                >
                                                    3. Ongoing Relationship
                                                </div>
                                                <div className={classes.sectionContainer} style={{ borderBottom: '1px solid #8EBF4C' }} id='disc-man-section-PU'>
                                                    <div className={classes.contentSecHeader} style={{ paddingTop: 0 }} id='disc-man-title-PU'>Discretionary Management</div>
                                                    <div className={classes.content} id='disc-man-content-PU'>
                                                        {discMngmt.content}
                                                        <p style={{ paddingTop: '32px' }} id='disc-man-sub-content-PU'>{discMngmt.subContent}</p>
                                                    </div>
                                                </div>
                                                <div className={classes.sectionContainer} style={{ paddingTop: '4px' }} id='adv-rel-section-PU'>
                                                    <div className={classes.contentSecHeader} id='adv-rel-title-PU'>Advisor Relationship</div>
                                                    <div className={classes.content} id='adv-rel-content-PU'>
                                                        {advRelationship.content}
                                                        <p style={{ paddingTop: '16px' }} id='adv-rel-sub-contnet-PU'>{advRelationship.subContent}</p>
                                                    </div>
                                                </div>
                                                <div className={classes.sectionContainer} style={{ padding: 0 }} id='ann-check-section-PU'>
                                                    <div className={classes.mobileSmallHeader} id='ann-check-title-PU'>Annual Check-In</div>
                                                    <div className={classes.subContent} id='ann-check-content-PU'>{advRelationship.annCheck}</div>
                                                </div>
                                                <div className={classes.sectionContainer} id='sem-ann-check-section-PU'>
                                                    <div className={classes.mobileSmallHeader} id='sem-ann-check-title-PU'>Semi-Annual Check-In</div>
                                                    <div className={classes.subContent} id='sem-ann-check-content-PU'>{advRelationship.semAnnCheck}</div>
                                                </div>
                                                <div id='view-acct-btn-container'>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        style={{ width: '100%', padding: '20px 0px' }}
                                                        onClick={() => setShow({ ...showContent, panel3: { isOpen: false }, panel2: { isOpen: true } })}
                                                        id='view-acct-btn'
                                                    >
                                                        <span style={{ paddingRight: '14px' }}>{'<'}</span>View Account Setup
                                                </Button>
                                                </div>
                                            </div>
                                        </Dialog>
                                    </Box>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}

export default ImplMethod;
